import { createTheme } from '@mui/material/styles'

const theme = createTheme({
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'sans-serif',
            '"PP Woodland"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        body1: {
            fontFamily: 'Manrope',
            fontSize: '1rem',
            lineHeight: '1.375rem',
            letterSpacing: '0.5px',
            fontWeight: 400,
        },
        body2: {
            fontFamily: 'Manrope',
            fontSize: '1rem',
            lineHeight: '1.375rem',
            letterSpacing: '0.5px',
            fontWeight: 400,
        },
        h1: {
            fontFamily: 'PP Woodland',
            fontWeight: 500,
            fontSize: '48px',
            color: '#303030',
        },
        h2: {
            fontFamily: 'PP Woodland',
            fontSize: '2.125rem',
            lineHeight: '2.5rem',
            fontWeight: 400,
            // fontWeight: 500,
        },
        h3: {
            fontFamily: 'Averta',
            fontSize: '1.5rem',
            lineHeight: '1.33',
            fontWeight: 600,
        },
        h4: {
            fontFamily: 'Averta',
            fontSize: '1.5rem',
            lineHeight: '1.33',
            fontWeight: 600,
        },
        h5: {
            fontFamily: 'Averta',
            fontSize: '1.5rem',
            lineHeight: '1.33',
            fontWeight: 600,
        },
        h6: {
            fontFamily: 'Averta',
            fontSize: '1.5rem',
            lineHeight: '1.33',
            fontWeight: 600,
        },
        button: {
            textTransform: 'none',
        },
        subtitle1: {
            fontFamily: 'Manrope',
            textTransform: 'uppercase',
            fontSize: '1rem',
            lineHeight: '1.5rem',
            letterSpacing: '0.15px',
            color: '#757575',
            fontWeight: 500,
        },
    },
    palette: {
        primary: {
            main: '#877594cc',
        },
        secondary: {
            main: '#fff',
        },
        error: {
            main: '#B00020',
        },
        background: {
            default: '#FBFBFA',
            paper: '#FBFBFA',
        },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    backgroundColor: ' #ffffff',
                    padding: '24px',
                    boxShadow: '5px 5px 20px 0px #0000001f',
                    border: '1px solid #a7a7a74a',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    borderBottom: '2px solid #f1f1f1',
                },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                root: {},
            },
        },
    },
})

export default theme
